import { z } from 'zod'

export const PriorSubmissionsSupplierFormCitationAgentInputSchema = z.object({
  type: z.literal('prior_submissions_supplier_form'),
  requestFormId: z.string().describe('Identifier of the prior supplier form (request_form) being cited'),
  questionName: z
    .string()
    .describe('The question name within the prior supplier form submission whose answer the anchor is taken from'),
  formTitle: z.string().describe('The form title containing the question on the prior supplier form submission'),
  anchor: z.string().trim().min(1).describe("Verbatim phrase copied from the prior supplier form answer's text"),
})

export const PriorSubmissionsSupplierFormCitationResolvedSchema = z.object({
  sourceType: z.literal('prior_submissions_supplier_form'),
  sourceLabel: z.string(),
  requestFormId: z.string(),
  supplierId: z.string(),
  questionName: z.string(),
  // Human-readable question title (resolver-supplied from the form config), for display; `questionName`
  // stays the stable identifier the agent cites by.
  questionTitle: z.string(),
  formTitle: z.string(),
  quote: z.string(),
  anchor: z.string(),
})
export type PriorSubmissionsSupplierFormCitationResolved = z.infer<typeof PriorSubmissionsSupplierFormCitationResolvedSchema>
